(() => {
  if (window.__shopPayInstallmentsStyled) return;
  window.__shopPayInstallmentsStyled = true;

  // shopify-payment-terms renders inside an open shadow root, so theme CSS
  // can't reach it. Adopt a sheet into the shadow root instead, it survives
  // the component re-rendering its content on variant change.
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    #shopify-installments,
    #shopify-installments p {
      margin: 0;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 1.48;
      font-family: var(--font-body-family);
      font-style: var(--font-body-style);
      color: rgba(var(--color-foreground), 1);
    }
  `);

  // The banner renders nothing when the variant isn't eligible (e.g. under
  // the £50 minimum), but the row still has padding/borders, and :empty can't
  // see shadow content. Hide the row based on what the shadow root rendered.
  const toggleRow = (el) => {
    const row = el.closest('.shop-pay-installments');
    if (!row) return;
    const content = el.shadowRoot.querySelector('#shopify-installments');
    // .hidden, not the hidden attribute, `.payment_services>div` sets display: flex
    row.classList.toggle('hidden', !content || content.textContent.trim() === '');
  };

  const apply = (el) => {
    const root = el.shadowRoot;
    if (!root || root.adoptedStyleSheets.includes(sheet)) return;
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];

    // Variant changes re-render inside the shadow root, which the document
    // observer below can't see, so watch the shadow root itself.
    toggleRow(el);
    new MutationObserver(() => toggleRow(el)).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  // The shadow root can be attached after the element is inserted, so retry
  // for a few frames before giving up on an element.
  const applyAll = (attempt = 0) => {
    const pending = Array.from(document.querySelectorAll('shopify-payment-terms'))
      .filter((el) => !el.shadowRoot);
    document.querySelectorAll('shopify-payment-terms').forEach(apply);
    if (pending.length && attempt < 30) requestAnimationFrame(() => applyAll(attempt + 1));
  };

  applyAll();
  document.addEventListener('DOMContentLoaded', () => applyAll());
  document.addEventListener('shades:updated', () => applyAll());
  // Cheap single pass on DOM changes, the retry loop only runs from the hooks above
  new MutationObserver(() => {
    document.querySelectorAll('shopify-payment-terms').forEach(apply);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
